import React, { useState } from "react";
import AppointmentCalendar from "../components/AppointmentCalendar";
import JoinAppointment from "./JoinAppointment";

const UpcomingAppointments = () => {
  const [isJoin, setIsJoin] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  if (isJoin && selectedAppointment) {
    return (
      <JoinAppointment
        appointment={selectedAppointment}
        isJoin={isJoin}
        setIsJoin={setIsJoin}
      />
    );
  }

  return <AppointmentCalendar />;
};

export default UpcomingAppointments;
